module.exports = __webpack_public_path__ + "static/media/light.892ed006.jpg";